import React, { useState } from 'react';
import './UpgradePrompt.css';
import { upgradeGuestToGoogle } from '../utils/authHelpers';

// ── Copy per trigger ───────────────────────────────────────────────────────────
const PROMPTS = {
  list_saved: {
    icon: '💾',
    title: "Save this list so you don't lose it",
    sub:  'Access it on any device and keep it safe',
    cta:  'Save with Google',
  },
  returning: {
    icon: '👋',
    title: 'Pick up where you left off — anywhere',
    sub:  'Sign in to keep your lists synced across devices',
    cta:  'Sign in with Google',
  },
  usage: {
    icon: '🛒',
    title: 'Want to keep this for next time?',
    sub:  'Sign in to save your lists and track prices',
    cta:  'Sign in with Google',
  },
};

// GoogleG icon
const GoogleIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" style={{ flexShrink: 0 }}>
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
  </svg>
);

function UpgradePrompt({ trigger, onDismiss }) {
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);
  const prompt = PROMPTS[trigger];
  if (!prompt) return null;

  const handleUpgrade = async () => {
    setLoading(true);
    setError(null);
    try {
      await upgradeGuestToGoogle();
      // Page will redirect to Google — loading state stays until redirect
    } catch (err) {
      setError('Something went wrong. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="upgrade-overlay" role="dialog" aria-modal="true" onClick={onDismiss}>
      <div className="upgrade-sheet" onClick={e => e.stopPropagation()}>
        <div className="upgrade-drag-handle" aria-hidden="true" />

        <div className="upgrade-icon" aria-hidden="true">{prompt.icon}</div>
        <h3 className="upgrade-title">{prompt.title}</h3>
        <p  className="upgrade-sub">{prompt.sub}</p>

        {error && <p className="upgrade-error">{error}</p>}

        <div className="upgrade-actions">
          <button
            className="upgrade-btn upgrade-btn--google"
            onClick={handleUpgrade}
            disabled={loading}
          >
            {loading
              ? <span className="upgrade-spinner" aria-hidden="true" />
              : <GoogleIcon />
            }
            {prompt.cta}
          </button>
          <button
            className="upgrade-btn upgrade-btn--dismiss"
            onClick={onDismiss}
            disabled={loading}
          >
            Not now
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpgradePrompt;
